import * as React from "react";
import { useContext } from "react";
import styled, { css } from "styled-components";
import { ActionContext } from "views/logic/ActionContext";
import Action from "views/components/actions/Action";
const FieldElement = styled.span.attrs({
  className: "field-element"
})(
  ({ $active, $disabled, theme }) => css`
    color: ${$active ? theme.colors.variant.info : "currentColor"};
    opacity: ${$disabled ? "0.3" : "1"};
  `
);
const FieldActions = ({ children, disabled, element, menuContainer, name, type, queryId }) => {
  const actionContext = useContext(ActionContext);
  const wrappedElement = ({ active }) => /* @__PURE__ */ React.createElement(FieldElement, { $active: active, $disabled: disabled }, element);
  const handlerArgs = { queryId, field: name, type, contexts: actionContext };
  return /* @__PURE__ */ React.createElement(Action, { element: wrappedElement, handlerArgs, menuContainer, type: "field" }, children);
};
export default FieldActions;
